import { IMAGES } from '../../lzapp_web_common_code/assets'

// Single source for the "Exam Essentials" flashcard-menu item (topic_id 200),
// referenced from every aicerts exam's GET_FLASH_CARD_MENU so the gating
// (requires_subscription) and icon can't drift per-exam. DataAI shipped it first.
// The chip background is not set here: the menu components resolve it from the
// item's `key` via @learnzapp/core/theme (getMenuChipBackground).
export const EXAM_ESSENTIALS_FLASH_ITEM = {
    title: 'Exam Essentials',
    image: IMAGES?.ic_flash_exam,
    menu: null,
    key: 'exam',
    topic_ids: [200],
    requires_subscription: true,
}
